<script>
import { createAxios } from 'sd-ajax'

const ajax = createAxios({
  baseURL: '//api.shuidichou.com',
  timeout: 60000
})
export default {
  name: 'CommonShare',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    this.initShare(this.shareData)
  },

  render () {
    return ''
  },

  methods: {
    initShare (callback) {
      ajax.post('https://api.shuidichou.com/api/cf/const/signature', {
        url: window.location.href
      }).then((res) => {
        let data = {
          appId: res.data.appid,
          nonceStr: res.data.noncestr,
          signature: res.data.signature,
          timestamp: res.data.timestamp
        }

        wx.config({
          ...data,
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone'
          ]
        })

        wx.ready(callback)
      })
    },

    async shareData () {
      let shareOpt = {}
      if (this.data.shareDataFrom === 'api') {
        let { response: shareApiResponse, data: reqParams, url, method = '' } = this.data.shareApi
        method = method.toLocaleLowerCase()

        let data = {}
        reqParams.forEach(item => {
          data[item.key] = this.$Utils.getResquestParam(item)
        })

        try {
          let result = await ajax[method](url, data)
          let getData = this.$Utils.getResponseData
          shareOpt = {
            title: getData(shareApiResponse.shareTitle, result),
            desc: getData(shareApiResponse.shareDesc, result),
            link: getData(shareApiResponse.shareLink, result) || window.location.href,
            imgUrl: getData(shareApiResponse.shareImg, result)
          }
        } catch (e) {
          console.error(e)
          return
        }
      } else {
        shareOpt = {
          title: this.data.shareTitle,
          desc: this.data.shareDesc,
          link: this.data.shareLink || window.location.href,
          imgUrl: this.data.shareImg
        }
      }

      wx.onMenuShareAppMessage(shareOpt)
      wx.onMenuShareTimeline(shareOpt)
      wx.onMenuShareAppMessage(shareOpt)
      wx.onMenuShareQQ(shareOpt)
      wx.onMenuShareQZone(shareOpt)
    }
  }
}
</script>
